import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
	root: {},
	aboutPolicy: {
		marginTop: theme.spacing(3),
	},
}));
